<template>
  <svg viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.15" cy="16.65" r="1.65" fill="white" />
    <circle cx="15.15" cy="22.65" r="1.65" fill="white" />
    <circle cx="15.15" cy="28.65" r="1.65" fill="white" />
    <rect x="18" y="15" width="12" height="3" rx="1" fill="white" />
    <rect x="18" y="21" width="12" height="3" rx="1" fill="white" />
    <rect x="18" y="27" width="12" height="3" rx="1" fill="white" />
  </svg>
</template>